export const useLanguage = () => {
  const lang: Ref<string> = useState('lang', () => useNuxtApp().$i18n.locale)

  async function setLanguage(_lang: string) {
    const { $i18n } = useNuxtApp()
    _lang = _lang || useRouter().currentRoute.value.path.split('/')[1]
    if (_lang === 'si') _lang = 'sl'
    if (!($i18n.locales.value as any[]).find(i => i.code === _lang)) _lang = $i18n.locale.value
    lang.value = _lang
    await $i18n.setLocale(_lang)
  }

  return {
    lang,

    setLanguage
  }
}
